module.exports = __webpack_public_path__ + "static/media/logo-nedvex-char.0d6aa3e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-nedvex-char.svg
// module id = 1601
// module chunks = 0